export default "__VITE_ASSET__e78deb53__"